import { Component, Inject, OnInit } from '@angular/core';
import { IconService } from './icons-setting/Icons.service';
import { CommonService } from './common.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { AppConfigService } from './app-config.service';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { AppVersionService } from './app-version.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM-DD-yyyy',
  },
  display: {
    dateInput: 'MM-DD-yyyy',
    monthYearLabel: 'DD/MM/YYYY',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'DD/MM/YYYY',
  },
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class AppComponent implements OnInit {
  title = this.commonService.projectName;

  constructor(@Inject(MAT_DATE_FORMATS) public dateFormat: any,
    private readonly iconService: IconService,
    public commonService: CommonService,
    private readonly dateAdapter: DateAdapter<any>,
    private readonly router: Router,
    private readonly appVersionService: AppVersionService,
    private readonly configService: AppConfigService) {
    dateFormat.parse.dateInput = configService.config.dateFormat?.toUpperCase();
    dateFormat.display.dateInput = configService.config.dateFormat?.toUpperCase();
    dateFormat.display.monthYearLabel = configService.config.dateFormat?.toUpperCase();
    dateFormat.display.monthYearA11yLabel = configService.config.dateFormat?.toUpperCase();
    this.iconService.registerIcons()
  }

  ngOnInit() {
    this.appVersionService.init();

    // Validate on every navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.appVersionService.checkVersion();
      });
  }
}
